import { Moment } from 'moment';
import { Project as DashboardProject } from '../../../common/dashboards/models/Project';
import { Profile } from '../../../common/models/Profile';
import { IssueStatistics } from './valueObjects/IssueStatistics';

export class Project extends DashboardProject {
  constructor(
    id: number,
    uuid: string,
    name: string,
    private readonly issueStatistics: IssueStatistics,
    lastAnalysis: Moment | null,
    private readonly profile: Profile | null,
    private readonly description: string | null,
    private readonly maxItemCount: number | null
  ) {
    super(id, uuid, name, lastAnalysis);
  }

  getIssues() {
    return this.issueStatistics;
  }

  getProfile() {
    return this.profile;
  }

  public getDescription(): string | null {
    return this.description;
  }

  public getMaxItemCount(): number {
    return this.maxItemCount ?? 0;
  }
}
